import { Outlet } from 'react-router-dom';

import { useParkingContext } from '@features/ownedParkingManage/contexts/ParkingContext';
import { PriceRulesProvider } from '@features/ownedParkingManage/contexts/PriceRulesContext';

export default function PriceRulesDataLayout() {
  const parking = useParkingContext();

  return (
    <PriceRulesProvider parkingId={parking.id}>
      <Outlet />
    </PriceRulesProvider>
  );
}
